module.exports = __webpack_public_path__ + "img/3hammer.a4643ea2.png";